
import { put, takeLatest, call } from 'redux-saga/effects';
import { FETCH_ALL_CREATERS, FETCH_ALL_CREATERS_FAILURE, FETCH_ALL_CREATERS_SUCCESS, FETCH_STUDENT_SUBCRIPTIONS, FETCH_STUDENT_SUBCRIPTIONS_SUCCESS, FETCH_TEACHER_SUBCRIBERS_FAILURE, FETCH_TEACHER_SUBCRIBERS_FROM_EXAMID, FETCH_TEACHER_SUBCRIBERS_SUCCESS, SUBSCRIBE_TO_TEACHER_FAILURE, SUBSCRIBE_TO_TEACHER_REQUEST, SUBSCRIBE_TO_TEACHER_SUCCESS, UNSUBSCRIBE_TO_TEACHER_FAILURE, UNSUBSCRIBE_TO_TEACHER_REQUEST, UNSUBSCRIBE_TO_TEACHER_SUCCESS } from '../actions/subscribers';
import axiosInstance from '../api/axiosInstance';


function* getsubscribers(action) {
  try {

    const testId = action.payload.testId
    const response = yield call(axiosInstance.get, `/subcount/${testId}`);
  
    const teacherdata = response.data.teacherProfile;
    const isSubscribed = response.data.isSubscribed
    yield put({ type: FETCH_TEACHER_SUBCRIBERS_SUCCESS, payload: {teacherdata,isSubscribed } });


  } catch (error) {

    yield put({ type: FETCH_TEACHER_SUBCRIBERS_FAILURE });

  }
}


function* subscribeToTeacherSaga(action) {
  try {  
 
    yield call(axiosInstance.post, "/subscribeToTeacher", action.payload);

    
    yield put({ type: SUBSCRIBE_TO_TEACHER_SUCCESS });
  } catch (error) {
    yield put({ type: SUBSCRIBE_TO_TEACHER_FAILURE, error: error.message });
  }
}


function* unsubscribeToTeacherSaga(action) {
  try {
      yield call(axiosInstance.post, "/unsubscribetoTeacher", action.payload);

      yield put({ type: UNSUBSCRIBE_TO_TEACHER_SUCCESS});
  } catch (error) {
      yield put({ type: UNSUBSCRIBE_TO_TEACHER_FAILURE, error: error.message });
  }
}



function* fetchStudentSubcriptionsSaga() {
  try {

     // Make a request to fetch user data from the backend with token in headers
     const response = yield call(axiosInstance.get, "/studentsubcriptions");

    
    const allSubscriptions = response.data;
    // Dispatch success action with user role
    yield put({ type: FETCH_STUDENT_SUBCRIPTIONS_SUCCESS, payload: allSubscriptions});
  } catch (error) {
    // Dispatch failure action on error
    // yield put({ type: FETCH_USER_DATA_FAILURE, payload: { error: error.message } });
  }
}


function* fetchAllCreaterSaga() {
  try {
    

     // Make a request to fetch user data from the backend with token in headers
     const response = yield call(axiosInstance.get, "/allcreater");

    
    const userData = response.data;
  

    // Dispatch success action with user role
    yield put({ type: FETCH_ALL_CREATERS_SUCCESS, payload: userData});
  } catch (error) {
    // Dispatch failure action on error
    yield put({ type: FETCH_ALL_CREATERS_FAILURE, payload: { error: error.message } });
  }
}



function* subscribersSaga() {
  yield takeLatest(FETCH_TEACHER_SUBCRIBERS_FROM_EXAMID, getsubscribers);
  yield takeLatest(SUBSCRIBE_TO_TEACHER_REQUEST, subscribeToTeacherSaga);
  yield takeLatest(UNSUBSCRIBE_TO_TEACHER_REQUEST, unsubscribeToTeacherSaga);
  yield takeLatest(FETCH_STUDENT_SUBCRIPTIONS, fetchStudentSubcriptionsSaga);
  yield takeLatest(FETCH_ALL_CREATERS, fetchAllCreaterSaga);


  

}


export default subscribersSaga;
